/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
module.exports = {
    tag: 'balance',
    quality: 0.2,
    perception: 1,
    dexterity: 1
}